import api from '@/api/api';
import Product from '../models/Product';

const state = {
  product_groups: [],
  modal_utilize: null,
  modal_send_fba: null,
  modal_send_fbm: null,
  modal_condition: null,
  modal_edit_products: null,
  loaded: false,
};

const getters = {

  getSelectedProducts: (state) => state.product_groups.filter((item) => item.length > 0)
    .map((items) => items.filter((item) => item.selected))
    .filter((item) => item.length > 0),

  getSelectedProductsIds: (state) => {
    const selected = state.product_groups.map((items) => items.filter((item) => item.selected));

    const ids = selected.filter((items) => items.length > 0)
      .map((items) => items.filter((item) => item.selected).map((item) => (
        typeof item.ids !== 'undefined' ? item.ids.slice(0, item.selected_quantity) : item.id
      )));

    const res = [];
    ids.map((items) => items.map((item) => res.push(item)));

    return res.flat();
  },

  modal_edit_products: (state) => state.modal_edit_products,

};

const mutations = {
  set_product_groups: (state, payload) => {
    state.product_groups = payload;
  },
  set_selected_utilize: (state, payload) => {
    state.modal_utilize = payload;
  },
  set_selected_send_fba: (state, payload) => {
    state.modal_send_fba = payload;
  },
  set_selected_send_fbm: (state, payload) => {
    state.modal_send_fbm = payload;
  },
  set_modal_condition: (state, payload) => {
    state.modal_condition = payload;
  },
  set_modal_edit_products: (state, payload) => {
    state.modal_edit_products = payload;
  },
  set_loaded: (state, payload) => {
    state.loaded = payload;
  },
};

const actions = {

  update_product(context, payload) {
    api().put(`${context.getters.get_app_section}/products`, payload)
      .then((resp) => {
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Products were changed.',
        });
        context.dispatch('isget_list');

        return resp;
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Products weren\'t changed. Please try again.',
        });
      });
  },

  isset_loaded: (context, payload) => {
    context.commit('set_loaded', payload);
  },

  is_update_condition: (context, payload) => {
    api().put(`${context.getters.get_app_section}/products/${payload.id}/update_condition`, payload.data)
      .then(() => context.commit('set_modal_condition', null))
      .then(() => {
        context.dispatch('isget_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Status was changed.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Status wasn\'t changed. Please try again.',
        });
      });
  },

  isset_selected_utilize: (context, payload) => {
    context.commit('set_selected_utilize', payload);
  },

  isset_selected_fba: (context, payload) => {
    context.commit('set_selected_send_fba', payload);
  },

  isset_selected_fbm: (context, payload) => {
    context.commit('set_selected_send_fbm', payload);
  },

  isget_list: (context) => {
    api().get(`${context.getters.get_app_section}/products/instock`)
      .then((resp) => resp.data)
      .then((data) => data.map((item) => {
        const products = item.map((subItem) => {
          const preparedItem = new Product(subItem);
          preparedItem.selected = false;
          preparedItem.isHidden = true;
          preparedItem.selected_quantity = subItem.quantity;
          preparedItem.valid = true;

          return preparedItem;
        });
        item.selectedPreview = false;

        return products;
      }))
      .then((productGroups) => context.commit('set_product_groups', productGroups))
      .then(() => context.commit('set_loaded', true))
      .catch((error) => {
        console.error('Error:', error);
        context.commit('set_loaded', null);
      });
  },

  isutilize_products: (context, payload) => {
    api().put(`${context.getters.get_app_section}/products/dispose`,
      JSON.stringify({ items: payload }))
      .then((resp) => resp.data)
      .then((data) => (data !== 'OK' ? null : data))
      .then(() => {
        context.dispatch('isget_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Products are ready for utilize.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Products weren\'t sent for ready for utilize. Please try again.',
        });
      });
  },

  iscreate_fba: (context, payload) => {
    api().post(`${context.getters.get_app_section}/shipments/fba`, payload)
      .then((resp) => resp.data)
      .then((data) => {
        if (data !== 'OK') throw new Error();

        return data;
      })
      .then(() => {
        context.dispatch('isget_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'FBA was created.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'FBA wasn\'t created. Please try again.',
        });
      });
  },

  iscreate_fbm: (context, payload) => {
    api().post(`${context.getters.get_app_section}/shipments/fbm`, payload)
      .then((resp) => resp.data)
      .then((data) => {
        if (data !== 'OK') throw new Error();

        return data;
      })
      .then(() => {
        context.dispatch('isget_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'FBM was created.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'FBM wasn\'t created. Please try again.',
        });
      });
  },

  isremove_products: (context, payload) => {
    api().put(`${context.getters.get_app_section}/products/return_to_inbound`,
      JSON.stringify({ items: payload }))
      .then((resp) => resp.data)
      .then((data) => (data !== 'OK' ? null : data))
      .then(() => {
        context.dispatch('isget_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Products were deleted.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Products weren\'t deleted. Please try again.',
        });
      });
  },

  isload_label_file: (context, payload) => api().post('/files/label', payload.form)
    .then((resp) => {
      const { data } = resp;

      payload.fbm_label = data.id;
      payload.fbm_label_link = data.url;
      payload.fbm_label_name = data.name;

      return resp;
    })
    .then((resp) => {
      context.dispatch('nt_set_notification', {
        type: 'inform',
        message: 'Label was saved.',
      });

      return resp;
    })
    .then((resp) => ({
      data: payload,
      resp,
    }))
    .catch((error) => {
      console.error('Error:', error);
      context.dispatch('nt_set_notification', {
        type: 'error',
        message: 'Label wasn\'t saved. Please try again.',
      });
    }),

  get_dimensions_from_amazon: (context, payload) => api().get(`analyzer/get_amazon_dimension/${payload}`)
    .then((resp) => {
      if (resp.status !== 200) throw new Error();

      return resp.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      context.dispatch('nt_set_notification', {
        type: 'error',
        message: 'Undefined server error',
      });
    }),
};

export default {
  state,
  getters,
  mutations,
  actions,
};
